import React from 'react';

import PropTypes from 'prop-types';

import DefaultSection from './Section';
import ImpoundSection from './Section/ImpoundSection';
import PrepaidSection from './Section/PrepaidSection';
import SectionK from './Section/SectionK';
import SectionL from './Section/SectionL';
import TaxesAndGovernmentFees from './Section/TaxesAndGovernmentFees';

const AccordionDetailsEdit = props => {
  switch (props.cdSection) {
    case 'E':
      return <TaxesAndGovernmentFees {...props} />;
    case 'F':
      return <PrepaidSection {...props} />;
    case 'G':
      return <ImpoundSection {...props} />;
    case 'K':
      return <SectionK {...props} />;
    case 'L':
      return <SectionL {...props} />;
    default:
      return <DefaultSection {...props} />;
  }
};

AccordionDetailsEdit.propTypes = {
  cdSection: PropTypes.string.isRequired,
};

export default AccordionDetailsEdit;
